import { generatePath } from 'react-router-dom'
import { AUTOPILOT_INTEGRATIONS_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Lightning, LightningFilled } from 'blaze-ui/icons'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useActivationSummary } from 'hooks/queries/integrations/useActivationSummary'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import Styles from './NavMenuAutopilotIntegrationsItem.module.scss'

interface Props {
  onPress: () => void
}

const NavMenuAutopilotIntegrationsItem = ({ onPress }: Props) => {
  const workspaceId = useCurrentWorkspaceId()
  const isActivationBannerEnabled = useFlipperFlag('home_v4')
  const { data } = useActivationSummary({ enabled: isActivationBannerEnabled })
  const providers = data?.providers ?? []
  const total = providers.length
  const connected = providers.filter((p) => p.connected).length

  return (
    <NavMenuItem
      icon={Lightning}
      activeIcon={LightningFilled}
      to={generatePath(AUTOPILOT_INTEGRATIONS_PATH, { workspaceId })}
      onPress={onPress}
      label="Integrations"
    >
      {isActivationBannerEnabled && total > 0 && <span className={Styles.counter}>{connected}/{total}</span>}
    </NavMenuItem>
  )
}

export { NavMenuAutopilotIntegrationsItem }
